/** Auto-generated UUID → game-name hints from Relum thumb filenames. */
export const RELUM_THUMB_HINTS = {
  '0101f687-c2b2-4027-a7b4-b26ed4f52977': "Cash 20 Queen of Luck 2",
  '0131a262-37ee-459e-99f0-be479902e64e': "Red 27",
  '03688a17-d3de-4063-bddd-9b4e40d384c6': "40 Mystic Gem Golden Coins Link 2",
  '03b4234e-123e-448b-9738-e8f1d92f6043': "e8f1d92f6043",
  '07a65948-bc5a-4e9d-8f3f-a367b1c21868': "40 Charming Joker",
  '0e9b0483-a003-4040-8728-2f9cd1824354': "2f9cd1824354",
  '144be652-4f2b-4ca6-b20d-2764d1362e2b': "2764d1362e2b",
  '14556407-ee1c-4dab-bc6d-dfa283b046e8': "dfa283b046e8",
  '17641fe4-44ef-4675-a227-821df80e344c': "UltraFresh",
  '180d5275-4a2e-4ffc-afcf-5d6f927c904e': "TempleCats",
  '1929cd42-515d-4c69-972e-2a3b23e73f2b': "2a3b23e73f2b",
  '1ae69e5d-fb87-4b3d-af14-938f72f23748': "Hermes Fortunes",
  '237cf352-c4fc-492e-875b-e09af9bc5191': "287x193",
  '23ef33e5-cce0-4ed3-9f4f-875a917ff655': "875a917ff655",
  '260d5949-f9cf-4123-963e-646abbba9b2c': "646abbba9b2c",
  '26ac0c3a-8472-4ee8-a4b9-feb7ead2549c': "feb7ead2549c",
  '27e94b5a-b17c-4711-bc31-24183bd4ae3d': "Cash 10 Royal Crown 1",
  '2ac7354f-bc3e-4b12-b49b-640cf4d9182c': "oriental dragon",
  '2afe5441-eb22-4e72-91e5-d4b5821c7b81': "287x193",
  '2c10832a-105b-42ea-9ed6-c44426ca3660': "Vampire Nigh Bell Link",
  '2f51941a-a9ac-4031-bd45-2fb9832a624a': "2fb9832a624a",
  '30e94f60-4fa6-4c76-b424-a50ab836907e': "Shining Crown Bell Link",
  '3442dd10-d4fd-4eab-a935-4f738090dbdd': "Cash 50 Royal Crown",
  '345bdacd-1853-46be-aace-dda9d78040ea': "40 Art of Gold Dice Edition Golden Coins Link",
  '34f90d05-32aa-485b-9618-d344f2664faf': "Jester Bags BB 1",
  '367970e2-33a5-43b6-9251-6742f5ac5598': "Shining Crown",
  '37b78e06-b832-4c90-b51a-e4eb370e804a': "Mummy Secret",
  '382a3f2f-534d-4cd6-8bf3-18e76bd41e96': "Star Signs",
  '3bf58fc9-0bf4-415c-8fa0-9334c10f8ce4': "Dragons Realm",
  '3dd6fb1d-f091-4555-8993-51066397532a': "Tiki Hut Megaways Jackpot Play",
  '3ddea773-27ec-41d8-a878-bbde55de499e': "EQ Egypt Sky 2",
  '3f66379d-687e-49d4-9fa4-0f4dd3674943': "Cash 20 Bonus Clover",
  '42f8ebf3-d8f7-45a2-bb6f-ff46ee149993': "Egg Rush Jackpot Play 1",
  '4821384a-45cf-480d-8fcb-914aaf665842': "914aaf665842",
  '4ab6ff22-abed-4f3d-ac0a-17d428d785b6': "17d428d785b6",
  '4afcb811-2e36-49e0-8bad-8c35c83a3980': "Tropical Pop Jackpot Play",
  '4d79412d-1905-413e-b8e7-1b3c97493c89': "40 Shining Crown Bell Link",
  '4db8c8de-e2ee-4366-acfb-9c68b42d8adc': "2020HitSlot",
  '51fb0dc0-5f37-4d0f-aa02-0102174f6026': "Cash 20 Lucky Clover 1",
  '553925c0-b676-48fd-a7b9-f927e1d2719d': "287x193 2",
  '5645355d-014d-492e-ae34-140530a26d3a': "Sugar Duke",
  '564f9c6d-35d7-408d-99cf-ae2104f8f491': "MongolTreasures",
  '5742aac6-42f3-44fc-8c2c-3e267fbeff7d': "Gameshow Party Jackpot Play 1",
  '5acd9c4e-e9cf-409c-9b71-9dd0ba842cec': "Cash 100",
  '5af32e5f-92a8-4847-8127-392c9e6b7631': "emirates2",
  '5d10efc7-5ea4-4d73-893f-69887cc015a2': "Kingdom of Atlantis Jackpot Play 2",
  '5fbad542-49d7-439c-9e0e-3c66d19ea52f': "3c66d19ea52f",
  '62f2a073-6383-4a7d-9cea-1b5c70e8cace': "1b5c70e8cace",
  '634f47ec-30b9-4fa8-b4b0-85e44d657f73': "85e44d657f73",
  '657cb4ae-ffe6-4ea1-a04e-26bb90859c20': "26bb90859c20",
  '66085d7c-2419-4543-a966-f8bec274a89c': "Adamant Bang 20",
  '69feb872-6408-4b46-afa0-516c3e584928': "Cash 100 Lucky Clover",
  '6fd1e1ba-9755-4bba-9ce5-8c9145ae5c0e': "40 Power Hot Dice Edition Golden Coins Link 4",
  '7199cadf-153c-4860-b860-13cf9fc044b3': "13cf9fc044b3",
  '7b686096-ba82-48c0-bc6d-cea2b5091ed0': "20 Burning Hot",
  '7c0e4c43-44b8-45c2-b8f4-0f41a238696d': "Sevens Heat 20",
  '7ee8ba8f-d286-42aa-af77-6f3cee667b1e': "Regal Spins 10 BB 1",
  '838e2716-bb03-4ac5-afef-b17fd05eed9a': "Sevens Joy 1",
  '86fbebd9-f6ca-4617-bfde-e0946a2c71cc': "40 Burning Hot Bell Link",
  '89500cbd-c4e8-49e0-9a99-dff3c61cbb70': "287x193 4",
  '8a1f22e0-4c5b-4c66-808f-cc50868bdc04': "40 Power Hot Golden Coins Link 2",
  '8ab2568a-22b5-42c2-8ab4-b942c58ec798': "Noble Fate 20 3",
  '913395d6-9627-498f-90a4-5aebe0bf3e33': "Princess Cash",
  '9387d52a-0e27-4d03-bc93-d50a772f4baf': "40 Extra Crown Golden Coins Link",
  '9f1b0deb-beaf-4e29-91c4-594836ac7567': "594836ac7567",
  'a1263aa2-138b-4011-9228-245cad4dab24': "245cad4dab24",
  'a59f2d49-3d79-48c1-8496-3c2a948b4825': "Bufona Alegre 10",
  'aa6e0d13-0ec0-40f8-8cdb-f701abae282f': "Leprechance Treasury",
  'abc332cc-09d9-4a48-a955-9ed44996539b': "Red Cap",
  'ac470550-d517-4993-a27c-ceec6c522645': "ceec6c522645",
  'b0bffe75-e1e9-4ced-8394-d9eb5cd102e2': "40 Mega Clover",
  'b5de0cf9-bbbf-42b3-9b50-8387b9121e8e': "Book of Shining Hot Jumboways",
  'b63341f8-eef3-4ee1-973f-230b32f4938e': "40 Super Fruits Bell Link",
  'b7860b4c-d6f9-402e-9024-eeb04c7ae811': "eeb04c7ae811",
  'b80901c8-10d8-41e9-b63f-0a3011505aa3': "LUCKY CLOVERLAND 11zon",
  'b9482118-e7b0-4148-b4de-e1cf2dfc54d7': "Sevens Play 3",
  'b9c3d84a-e6b4-4a14-b549-797f5c41ee6c': "Shining Crown 2",
  'c4517b4b-74db-40f1-beca-3a6fdd3e0eac': "Sugartime",
  'c7b0d197-efc7-4d54-9b9e-25d06add05ce': "100 Bulky Fruits Golden Coins Link",
  'c96b682f-22aa-46e8-af44-9e0c9ff8bbb7': "Leprechaun Hot",
  'c9c3b668-1fe5-48c7-b4a3-63da3fa343cb': "40 Super Hot Bell Link",
  'cc5a9041-16c7-49cf-bbeb-0ec5f501952f': "0ec5f501952f",
  'd07196a3-a71c-43c0-a7f4-ef201d626e7b': "40 Extra Crown Classic Dice Golden Coins Link",
  'd448c08d-f460-41b9-921e-5f94c9851e42': "Flaming Hot Extreme Bell Link",
  'd7e82f96-af31-4a73-b4b5-a65617aa01e9': "a65617aa01e9",
  'd9b8dd2d-32de-4a3a-860a-e934eb215acc': "40 Lucky King Extreme Bell Link 1",
  'dbae761d-2c44-4913-81bb-465dd82acd9e': "465dd82acd9e",
  'dd652312-66a2-4232-9d52-ca6d82ff2169': "King Cash 10",
  'de242029-6dbc-4a30-84fc-10684f04d4d7': "Lucky Streak 2",
  'df17bb48-4200-4bce-b5fa-484a0cc40350': "Art of Gold Golden Coins Link 1",
  'e2da3217-fab4-410e-95f3-1799543ac2b4': "287x193 5",
  'e56d1225-a17f-42cd-87d0-f0674ede3cea': "10 Burning Heart",
  'e8fa1e03-cbb2-4cc5-a1ab-c5395f251e17': "c5395f251e17",
  'eca90e5e-4a23-40e8-ab65-ed4951f1beb6': "Cash 40",
  'f02372e7-92a9-4337-a28f-6c4a8396e6d4': "40LuckyKingBellLink",
  'f1235872-cf37-49c3-b795-79d2ddde70b7': "20 Glossy Hot Golden Coins Link 1",
  'f75806d8-afe8-41b1-8dfa-a7562323ad47': "Pure Ecstasy",
  'f889120c-ba69-4270-a47e-4a108316e57b': "4a108316e57b",
  'fb2d6733-12ea-4cfd-8214-77604028c28a': "100 Bulky Dice Golden Coins Link 1",
  'fdf38842-a05f-48a9-a113-76760852ae2b': "40 Zodiac Wheel Bell Link",
};

